import { VIRTUAL_MARKETER_ONBOARDING_PATH } from 'paths'
import { generatePath, Redirect, useLocation } from 'react-router-dom'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { observer } from 'mobx-react-lite'
import { useLoggedIn } from 'hooks/useLoggedIn'
import { PropsWithChildren } from 'react'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

const VirtualMarketerOnboardingRedirectContainer = observer(({ children }: PropsWithChildren) => {
  const isLoggedIn = useLoggedIn()
  const workspaceId = useCurrentWorkspaceId()
  const currentWorkspace = useCurrentWorkspace()
  const location = useLocation()

  if (!isLoggedIn) return <>{children}</>

  const isTestPath = location.pathname.includes('vm-onboarding-test')

  if (
    currentWorkspace?.is_virtual_marketer &&
    !currentWorkspace?.is_virtual_marketer_onboarding_completed &&
    !isTestPath
  ) {
    return <Redirect to={generatePath(VIRTUAL_MARKETER_ONBOARDING_PATH, { workspaceId })} />
  }

  return <>{children}</>
})

export { VirtualMarketerOnboardingRedirectContainer as VirtualMarketerOnboardingWrapper }
